import React, { useState, useEffect } from 'react';
import clsx from 'clsx';
import { Draggable, DropBin } from '@/components';

interface GrabGameBuildWordsProps {
  word: string;
  parts1: Array<string>;
  parts2: Array<string>;
}

export const GrabGameBuildWords = ({
  word,
  parts1,
  parts2,
}: GrabGameBuildWordsProps) => {
  const [value1, setValue1] = useState<string | undefined>(undefined);
  const [value2, setValue2] = useState<string | undefined>(undefined);
  const [isCorrect, setIsCorrect] = useState(false);

  useEffect(() => {
    if (!value1 || !value2) {
      setIsCorrect(false);

      return;
    }

    setIsCorrect(`${value1}${value2}` === word);
  }, [value1, value2, word]);

  return (
    <div className="flex flex-col gap-6 justify-center items-center h-full pb-24">
      <div className="flex gap-6 justify-center">
        {parts1.map((part, index) => (
          <Draggable
            key={index}
            className="h-24 px-3 bg-white rounded-xl text-8xl font-sassoonInfant"
            value={part}
          >
            {part}
          </Draggable>
        ))}
      </div>

      <div className="flex gap-3 justify-center">
        <DropBin
          className={clsx(
            'h-24 px-3 font-sassoonInfant text-8xl text-left',
            !value1 || !value2
              ? 'bg-white text-black'
              : isCorrect
                ? 'bg-[var(--c-success)] text-white'
                : 'bg-[var(--c-select)] text-white',
          )}
          value={value1}
          setValue={setValue1}
          showValue
        />

        <DropBin
          className={clsx(
            'h-24 min-w-36 px-2 font-sassoonInfant text-8xl text-left',
            !value2 || !value1
              ? 'bg-white text-black'
              : isCorrect
                ? 'bg-[var(--c-success)] text-white'
                : 'bg-[var(--c-select)] text-white',
          )}
          value={value2}
          setValue={setValue2}
          showValue
        />
      </div>

      <div className="flex gap-6 justify-center">
        {parts2.map((part, index) => (
          <Draggable
            key={index}
            className="h-24 px-3 bg-white rounded-xl text-8xl font-sassoonInfant"
            value={part}
          >
            {part}
          </Draggable>
        ))}
      </div>
    </div>
  );
};
